import Vue from 'vue';

export default {
  state: {
    companyLoad: [],
  },
  getters: {
    companyLoad(state) {
      return state.companyLoad;
    },
  },
  mutations: {
    SET_COMPANY_LOAD(state, payload) {
      state.companyLoad = payload;
    },
  },
  actions: {
    GET_COMPANY_LOAD(context) {
      return Vue.axios.get('filters/company_load').then((response) => {
        context.commit('SET_COMPANY_LOAD', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/company_load.js